import { render } from "./GearTable.vue?vue&type=template&id=480ba086&scoped=true&ts=true"
import script from "./GearTable.vue?vue&type=script&lang=ts"
export * from "./GearTable.vue?vue&type=script&lang=ts"

import "./GearTable.vue?vue&type=style&index=0&id=480ba086&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480ba086"]])

export default __exports__